import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const oldJiraHomeRoute: InvariantJiraRoute = {
	name: 'your-work',
	path: '/jira/your-work',
};
